import { useGtag } from "vue-gtag-next";

const GA_MEASUREMENT_ID = (import.meta.env.VITE_GA_MEASUREMENT_ID || '').trim();
const gtagApi = GA_MEASUREMENT_ID
    ? useGtag()
    : { screenview: () => {}, event: () => {} };
const { screenview, event } = gtagApi;

interface err {
    message: string,
    description: string
}

/** 加密货币（TOKEN）在界面上的统一小数位数 */
export const TOKEN_FRACTION_DIGITS = 8;

export function getError({ title = "UNKNOWN ERROR", message = "Unknown error", data = {name:'Error', message:'Unknown error'}, placement = 'topRight'  } = {}):err{
    let result = {
        message: title,
        description: message,
        placement,
        class: 'otcpro-error-notification',
      }
      if (data) {
          if(data.name) {
            result.message = data.name;
          }
          if(data.message) {
            result.description = data.message;
          }
      }
      return result;
}

export function getAmount(amount = 0, type = 'TOKEN'):string {
    return type === 'TOKEN'
      ? formatTruncatedNumber(Number(amount), TOKEN_FRACTION_DIGITS)
      : formatTruncatedCurrency(Number(amount), 'USD');
}

export function truncateNumber(value = 0, digits = 0): number {
    if (!Number.isFinite(value)) return 0;
    const factor = 10 ** digits;
    return value < 0 ? Math.ceil(value * factor) / factor : Math.floor(value * factor) / factor;
}

export function formatTruncatedNumber(value = 0, digits = TOKEN_FRACTION_DIGITS): string {
    const truncated = truncateNumber(value, digits);
    return Intl.NumberFormat('en-US', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(truncated);
}

export function formatTruncatedCurrency(value = 0, currency = 'USD'): string {
    const truncated = truncateNumber(value, 2);
    return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(truncated);
}

export function formatAmountByAsset(value = 0, assetName = ''): string {
    const fiatAssets = new Set(['USD', 'AUD', 'NZD', 'GBP']);
    if (fiatAssets.has(String(assetName).toUpperCase())) {
        return formatTruncatedCurrency(Number(value), String(assetName).toUpperCase());
    }
    return formatTruncatedNumber(Number(value), TOKEN_FRACTION_DIGITS);
}

export function parseAddress({ address = '', network = 'ETH' }):string {
  return address;
}

export const gtagScreenview = (screen_name: string) => {
  screenview({
      screen_name,
      app_name: 'OTCPRO'
  })
}

export const gtagEvent = ({ name, event_category, event_label }: {
  name: string;           
  event_category: string; 
  event_label: string;    
}) => {
  
  event(name, {
      event_category,  
      event_label,     
  });
}
